<h4
  *ngIf="showHeader"
  mat-dialog-title
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle
  cdkDragBoundary=".cdk-overlay-container"
>
  <span class="title">{{ title || headerText }}</span>
  <button
    mat-icon-button
    tabindex="-1"
    *ngIf="settingsMenuItems"
    [matMenuTriggerFor]="settingsMenuItems"
  >
    <mat-icon class="settings-icon">settings</mat-icon>
  </button>
  <button
    *ngIf="enableMaximize"
    matTooltip="{{ isMaximised ? 'Restore Down' : 'Maximise' }}"
    tabindex="-1"
    mat-icon-button
    (click)="maximise()"
  >
    <mat-icon aria-hidden="false">{{ isMaximised ? 'fullscreen_exit' : 'fullscreen' }}</mat-icon>
  </button>
  <button
    tabindex="-1"
    *ngIf="!hideCloseIcon"
    (click)="closeDialog()"
    mat-icon-button
    matTooltip="Close"
    class="close-icon"
  >
    <mat-icon aria-hidden="false">close</mat-icon>
  </button>
  <div *ngIf="hideCloseIcon" layout-align="end center">
    <ng-content select="[nibras-dialog-header-actions]"></ng-content>
  </div>
</h4>
<div mat-dialog-content [ngClass]="{ 'no-footer': !showFooter }">
  <ng-content select="[nibras-dialog-content]"></ng-content>
</div>
<div *ngIf="showFooter" mat-dialog-actions class="footer" [align]="'end'">
  <ng-content select="[nibras-dialog-footer]"></ng-content>
</div>
